import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import {
  SALES_CATALYST_DEFAULT_SELECTED_TAB, SALES_CATALYST_FEATUREID, PAGE_VISIT_SALES_CATALYST,
  SALES_CATALYST_COLOR_CODE,
} from '../constants';
import SalesCatalystToolPalate from '../components/common/SalesCatalystToolPalate';
import * as salesCatalystActions from '../actions/salesCatalystActions';
import * as preferenceActions from '../actions/preferencesActions';
import SalesCatalystContent from '../components/salesCatalyst/SalesCatalystContent';
// For Coming Soon Teaser
import SalesCatalystComingSoonTeaser from
  '../components/salesCatalyst/SalesCatalystComingSoonTeaser/SalesCatalystComingSoonTeaser';
import SalesCatalystComingSoonToolPalate from
  '../components/salesCatalyst/SalesCatalystComingSoonTeaser/SalesCatalystComingSoonToolPalate';
import { isFeaturePresent } from '../util/CommonUtils';
import { saveTrackingData, storeUnsavedData } from '../util/trackerUtils';
import WarningIcon from './WarningIcon';

class SalesCatalyst extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: SALES_CATALYST_DEFAULT_SELECTED_TAB,
      smartSearchStudy: undefined,
      studies: this.props.studies !== undefined ? this.props.studies : [],
      hasSCStudies: true,
    };
  }

  componentDidMount() {
    sessionStorage.removeItem('subModule');
    this.onMountMethod();
    // this.renderComingSoonTeaser();
    window.addEventListener('beforeunload', this.handleLeavePage);
  }

  getPreferenceColorKeys = key => {
    const colorObj = _.find(this.state.preferenceColorKeys, key);
    return colorObj !== undefined ? colorObj[key] : '';
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.hasSCStudies !== nextProps.hasSCStudies) {
      this.setState({ hasSCStudies: nextProps.hasSCStudies });
    }

    if (nextProps.salesCatalystStudy) {
      this.setState({ smartSearchStudy: nextProps.salesCatalystStudy });
    }
    if (nextProps.studies) {
      this.setState({ studies: nextProps.studies });
    }
    if (nextProps.scSessionConfiguration !== undefined &&
      !_.isEmpty(nextProps.scSessionConfiguration)) {
      _.forEach(SALES_CATALYST_COLOR_CODE, colorObj => {
        const colorKey = colorObj.key;
        colorObj.color = nextProps.scSessionConfiguration._sc[colorKey] !== 'undefined'
          ? nextProps.scSessionConfiguration._sc[colorKey] : 'transparent';
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  onMountMethod = () => {
    if (this.props.loginResponse && this.hideComingSoonTeaser()) {
      if (this.props.salesCatalystStudy === undefined) {
        this.props.salesCatalystActions.getsalesCatalystStudy(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
        );
      } else {
        this.setState({
          smartSearchStudy: this.props.salesCatalystStudy,
        });
      }
    }

    if (this.props.loginResponse) {
      this.callSaveTrackerFn({ action: PAGE_VISIT_SALES_CATALYST });
      this.props.preferenceActions.setLastLocation({
        mainMenu: 'Catalyst',
        mainModule: 'SalesCatalyst',
      });
    }

    const { hasSCStudies } = this.props;
    if (hasSCStudies === undefined) {
      this.setState({ hasSCStudies: true });
    } else {
      this.setState({ hasSCStudies });
    }
  }

  callSaveTrackerFn = ({ subModule = this.state.selectedTab, action }) => {
    if (subModule) {
      sessionStorage.setItem('subModule', subModule);
    }
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      action,
      moduleName: 'SalesCatalyst',
      subModule,
      productNo: this.props.salesCatalystStudy !== undefined ?
        this.props.salesCatalystStudy.pn : undefined,
    });
  }

  handleLeavePage = () => {
    this.props.storeUnsavedData(
      this.props.currentState,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId
    );
  }

  selectTab = tabName => {
    this.setState({ selectedTab: tabName });
  };

  // For Coming Soon Teaser
  hideComingSoonTeaser = () => {
    const { modulePermissions } = this.props;
    let renderSalesCatalyst = false;
    if (modulePermissions.length > 0) {
      renderSalesCatalyst = isFeaturePresent(SALES_CATALYST_FEATUREID, modulePermissions);
    }
    return renderSalesCatalyst;
  }

  render() {
    return (
      (this.hideComingSoonTeaser()) ?
        <div>
          {this.state.hasSCStudies ?
            <div>
              <SalesCatalystToolPalate
                onselectedtab={this.selectTab}
                selectedTab={this.state.selectedTab}
                trackerFn={this.callSaveTrackerFn}
              />
              <div
                className="salescatalyst-width-955 portfolio-crosstab float-left"
                style={{
                  overflowY: 'auto',
                  height: 'calc(100vh - 57px)',
                  overflowX: 'hidden',
                }}
              ><SalesCatalystContent
                studies={this.state.studies}
                smartSearchStudy={this.state.smartSearchStudy}
                selectedTab={this.state.selectedTab}
                color={SALES_CATALYST_COLOR_CODE}
              /></div>
            </div> :
            <div className="no-study-message">
              <WarningIcon />
              <p>
                You do not currently have studies to the Sales Catalyst application.
                Please contact your Account Manager to learn more about your studies.
              </p>
            </div>
          }
        </div> :
        <div>
          <SalesCatalystComingSoonToolPalate />
          <div
            className="salescatalyst-width-955 portfolio-crosstab float-left"
            style={{
              overflowY: 'auto',
              height: 'calc(100vh - 57px)',
              overflowX: 'hidden',
            }}
          ><SalesCatalystComingSoonTeaser /></div>
        </div>
    );
  }
}

SalesCatalyst.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
    }),
  }),
  salesCatalystStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  studies: PropTypes.arrayOf(PropTypes.object),
  activeAccountId: PropTypes.number,
  modulePermissions: PropTypes.instanceOf(Array),
  storeUnsavedData: PropTypes.func,
  currentState: PropTypes.shape({}),
  preferenceActions: PropTypes.shape({
    setLastLocation: PropTypes.func,
  }),
  hasSCStudies: PropTypes.bool,
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    salesCatalystStudy: state.study.salesCatalystStudy,
    studies: state.study.salesCatalystStudies,

    activeAccountId: state.account.activeAccountId,
    modulePermissions: state.userDetail.permissions,
    currentState: state,
    preferences: state.preferences,
    scSessionConfiguration: state.salesCatalyst.scSessionConfiguration,
    hasSCStudies: state.study.hasSCStudies,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
    storeUnsavedData: bindActionCreators(storeUnsavedData, dispatch),
    preferenceActions: bindActionCreators(preferenceActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SalesCatalyst);
